import { TFileLocal } from '../../typings/attachments';
import { NodeEnv, ServerError } from '../constants/common';
import { ErrorPhrase } from '../constants/phrases';

export const extend = <ObjA, ObjB>(a: ObjA, b: ObjB): ObjA & ObjB => ({
  ...a,
  ...b,
});

export const isEnvDevelopment = () =>
  (process.env.REACT_APP_ENV || process.env.NODE_ENV) === NodeEnv.DEVELOPMENT;

export const getUniqueId = (idLength = 7): string => {
  let text = '';
  const possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < idLength; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

export const getSourceUrl = () => {
  if (document.referrer) {
    return document.referrer;
  }

  return window.location.href;
};

export const getErrorText = (err: ServerError): string => {
  switch (err) {
    case ServerError.USER_NOT_FOUND:
      return ErrorPhrase.NO_USER_ID;
    case ServerError.USER_PAGES_RUN_OUT:
      return ErrorPhrase.NO_AVAILABLE_PAGES;
    default:
      return ErrorPhrase.NO_USER_ID;
  }
};

export const getAdditionalFilesIds = (files: TFileLocal[]) =>
  files.map((file) => file.additionalId);

export const reloadPage = () => {
  window.location.reload();
};
